import React, { useRef } from "react";
import { useNavigate } from "react-router";
import { format } from "date-fns";
import OutlineButton from "../forms/buttons/OutlineButton";
import Button from "../forms/buttons/Button";

/**
 * トップページのサブヘッダーコンポーネント
 * @param {Function} onRefresh 一覧再読み込み時の処理
 * @class TopHeader
 */
export default function TopHeader({ onRefresh }) {
  const navigate = useNavigate();
  const lastUpdatedAt = format(new Date(), "HH:mm:ss");
  const refreshRef = useRef(null);

  /**
   * 再読み込み時のボタンアニメーション処理
   * @memberof TopHeader
   */
  const onRefreshClick = () => {
    if (refreshRef?.current) {
      refreshRef.current?.animate(
        [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
        { duration: 360, easing: "ease-out" },
      );
    }
    onRefresh();
  };
  return (
    <div className="page-top">
      <div className="page-title">
        <p className="eyebrow">WORK ORDER</p>
        <h1>作業指示一覧</h1>
        <p className="last-updated" id="lastUpdated">
          {`最終更新：${lastUpdatedAt}`}
        </p>
      </div>

      <div className="top-buttons">
        <OutlineButton
          title="一覧更新"
          icon="refresh"
          buttonRef={refreshRef}
          onClick={onRefreshClick}
        />
        <Button
          title="手動入力"
          icon="plus"
          onClick={() => navigate("/work-contents/create")}
        />
      </div>
    </div>
  );
}
